<script>
    import MediaInput from '../common/Media/MediaInput.svelte';
    import Modal from '../Modal.svelte';
    import {sgettext} from '../../i18n.js';

    export let media = null;
    export let width = '160px';
    export let height = '90px';
    export let onChange = () => {};
    export let onRemove = () => {};
    export let isValid = true;
    export let errors = '';


    let toolImageSelectionModalId = 'globalToolImageSelectionModal';

    function onRemoveClick(event){
        onRemove(media);
    }

</script>

<style>
    .element-media-input {
        position: relative;
        display: flex;
        flex-direction: row;
        height: 100%;
        width: 100%;
    }
    .actions-bar {
        display: flex;
        flex-direction: column;
        padding: 6px;
        height: 100%;
        text-align: center;
    }

    .actions-bar:hover .fas {
        opacity: 1;
    }

    .actions-bar .fas {
        margin-bottom: 16px;
        opacity: 0.5;
        cursor: pointer;
    }

    .actions-bar .fas:hover {
        color: #dd5900;
    }

    .errors {
        color: #dc3545;
        font-size: 13px;
    }
</style>

<div class="element-media-input my-element-media-input">
    <MediaInput
        bind:media={media}
        {width}
        {height}
        {onChange}
        {onRemove}
        showLibrary={false}
        extraStyle="border-radius: 3px;"
    />

    {#if media && (Object.keys(media).length || media.size) }
        <div class="actions-bar">
            <i
                class="fas fa5-trash-alt"
                title={sgettext("$$REMOVE$$")}
                on:click={onRemoveClick}></i>
        </div>
    {/if}
</div>
{#if !isValid}
    <div class="errors">{errors}</div>
{:else}
    <div class="errors"></div>
{/if}
